module.exports = __webpack_public_path__ + "img/part-tree-mobile.23d47d45.jpg";